/* eslint-disable max-len */
function PrintSvg(props: React.SVGProps<SVGSVGElement>): React.PropsWithoutRef<React.ReactSVGElement> {
    return <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_38017_7290" style={{maskType: 'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18">
            <rect width="18" height="18" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_38017_7290)">
            <path d="M5.09958 11.9062H3.825C3.36937 11.9062 3 11.5897 3 11.1991V6.42589C3 6.03535 3.36937 5.71875 3.825 5.71875H14.55C15.0056 5.71875 15.375 6.03535 15.375 6.42589V11.1991C15.375 11.5897 15.0056 11.9062 14.55 11.9062H13.3306" stroke="#39404D" strokeWidth="1.125" />
            <path d="M5.0625 5.71875V3.65625C5.0625 3.08671 5.52421 2.625 6.09375 2.625H12.2812C12.8508 2.625 13.3125 3.08671 13.3125 3.65625V5.71875" stroke="#39404D" strokeWidth="1.125" />
            <path d="M12.2812 9.84375H6.09375C5.52421 9.84375 5.0625 10.3055 5.0625 10.875V13.9688C5.0625 14.5383 5.52421 15 6.09375 15H12.2812C12.8508 15 13.3125 14.5383 13.3125 13.9688V10.875C13.3125 10.3055 12.8508 9.84375 12.2812 9.84375Z" stroke="#39404D" strokeWidth="1.125" />
        </g>
    </svg>;
}

export default PrintSvg;
